module.exports = __webpack_public_path__ + "static/media/who-it-works-2.06a28df0.png";